const THEME = {
  primary: "#1a365d",
  secondary: "#2d4a6f",
  accent: "#e67e22",
  success: "#27ae60",
  warning: "#f39c12",
  danger: "#e74c3c",
  info: "#3498db",
  light: "#f8fafc",
  dark: "#1e293b",
  gradient: "linear-gradient(135deg, #1a365d 0%, #2d4a6f 100%)",
  cardShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
  borderRadius: "12px",
};

export default THEME;
